import React from 'react';
import { RefreshCw, Download, Clock } from 'lucide-react';
import { Button } from '../ui/Button';
import { Select } from '../ui/Select';
import { DateRangePicker } from '../ui/DateRangePicker';
import { Badge } from '../ui/Badge';
import { DashboardFilterState, User } from '../../types/dashboard';
interface DashboardFiltersProps {
  filters: DashboardFilterState;
  onFilterChange: (filters: DashboardFilterState) => void;
  users: User[];
  lastRefreshed: Date;
  onRefresh: () => void;
  onExport: () => void;
}
export function DashboardFilters({
  filters,
  onFilterChange,
  users,
  lastRefreshed,
  onRefresh,
  onExport
}: DashboardFiltersProps) {
  const userOptions = users.map(u => ({
    value: u.id,
    label: u.name
  }));
  return <div className="bg-white border-b border-gray-200 sticky top-0 z-20 shadow-sm" data-id="element-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-51">
        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4" data-id="element-52">
          {/* Left: Filters */}
          <div className="flex flex-col md:flex-row gap-4 flex-1" data-id="element-53">
            <div className="w-full md:w-64" data-id="element-54">
              <Select label="Team Members" options={userOptions} value={filters.selectedUsers} onChange={vals => onFilterChange({
              ...filters,
              selectedUsers: vals
            })} multi searchable placeholder="Select users..." data-id="element-55" />
            </div>

            <div className="flex-1" data-id="element-56">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-57">
                Time Period
              </label>
              <DateRangePicker selectedPreset={filters.preset} onPresetChange={preset => onFilterChange({
              ...filters,
              preset
            })} dateRange={filters.dateRange} onRangeChange={range => onFilterChange({
              ...filters,
              dateRange: range
            })} data-id="element-58" />
            </div>
          </div>

          {/* Right: Actions & Meta */}
          <div className="flex flex-col sm:flex-row items-end sm:items-center gap-3 pt-4 lg:pt-0" data-id="element-59">
            <div className="flex items-center text-xs text-gray-500 mr-2 bg-gray-50 px-3 py-1.5 rounded-full border border-gray-100" data-id="element-60">
              <Clock className="h-3 w-3 mr-1.5" data-id="element-61" />
              <span data-id="element-62">
                Updated:{' '}
                {lastRefreshed.toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit'
              })}
              </span>
              <span className="mx-2" data-id="element-63">•</span>
              <Badge variant="success" size="sm" data-id="element-64">
                Fresh
              </Badge>
            </div>

            <div className="flex gap-2" data-id="element-65">
              <Button variant="secondary" size="sm" leftIcon={<RefreshCw className="h-3 w-3" data-id="element-67" />} onClick={onRefresh} data-id="element-66">
                Refresh
              </Button>
              <Button variant="outline" size="sm" leftIcon={<Download className="h-3 w-3" data-id="element-69" />} onClick={onExport} data-id="element-68">
                Export
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}